let $ = require("jquery");
import PerfectScrollbar from 'perfect-scrollbar';
$(function(){

  'use strict'

  // $('[data-toggle="tooltip"]').tooltip()

  const asideBody = new PerfectScrollbar('.aside-body', {
    suppressScrollX: true
  });

  var mql = window.matchMedia('(min-width:992px) and (max-width: 1199px)');

  function doMinimize(e) {
    if (e.matches) {
      $('.aside').addClass('minimize');
    } else {
      $('.aside').removeClass('minimize');
    }

    asideBody.update()
  }

  mql.addEventListener(typeof doMinimize, doMinimize);
  doMinimize(mql);

  $('.aside-menu-link').on('click', function(e){
    e.preventDefault()

    if(window.matchMedia('(min-width: 992px)').matches) {
      $(this).closest('.aside').toggleClass('minimize');
    }

    asideBody.update()
  })

  $('.nav-aside .with-sub').on('click', '.nav-link', function(e){
    e.preventDefault();

    $(this).parent().siblings().removeClass('show');
    $(this).parent().toggleClass('show');

    asideBody.update()
  })

  $('body').on('mouseenter', '.minimize .aside-body', function(){
    $(this).parent().addClass('maximize');
  })

  $('body').on('mouseleave', '.minimize .aside-body', function(){
    $(this).parent().removeClass('maximize');

    asideBody.update()
  })

  // $('body').on('click', '.aside-backdrop', function(){
  //   $('body').removeClass('show-aside');
  // })
})
